/**
 * @fileoverview PUT handler for the "/engagement/campaigns/set_global_rate_limits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsSetGlobalRateLimitsCacheKeys } from "./constants";
import type {
  PutEngagementCampaignsSetGlobalRateLimitsProps,
  EngagementCampaignsSetGlobalRateLimitsResult,
} from "./types";

export const putEngagementCampaignsSetGlobalRateLimits = reactQueryMutationAdapter(
  engagementCampaignsSetGlobalRateLimitsCacheKeys,
  (
    props: PutEngagementCampaignsSetGlobalRateLimitsProps
  ): Promise<EngagementCampaignsSetGlobalRateLimitsResult> => {
    return fetch("/engagement/campaigns/set_global_rate_limits", "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
